"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDateColumnFilterSortConfig = void 0;
const react_1 = require("react");
const ui_components_1 = require("@groupby/ui-components");
const useDateColumnFilterSortConfig = () => {
    const getFilterConfig = (0, react_1.useCallback)(() => ({
        type: 'date',
        filterable: true,
        sortable: true,
        filterOperators: (0, ui_components_1.createDateFilterOperators)({ inputProps: {} })
            .map((operator) => (Object.assign(Object.assign({}, operator), { label: '' }))),
    }), []);
    return getFilterConfig;
};
exports.useDateColumnFilterSortConfig = useDateColumnFilterSortConfig;
